<div class="header">
  <h3>
    <i *ngIf="icon" class="fas" [ngClass]="icon"></i> {{ listTitle }}
    <span *ngIf="usersCount && accountSettings" class="font-weight-normal">
      ({{ usersCount }}/{{ accountSettings.userSeats }})
    </span>
  </h3>
  <button
    *ngIf="accountId && !deactivated && !support"
    class="btn btn-primary btn-sm"
    (click)="downloadReport.emit()"
    [disabled]="isDownloadingReport"
    ngbTooltip="Download user report as Excel file"
  >
    <i
      class="fas"
      [ngClass]="isDownloadingReport ? 'fa-spinner fa-spin' : 'fa-download'"
    ></i>
    User report
  </button>
</div>
<app-table>
  <app-table-headers>
    <app-table-header class="flex-half picture-cell"></app-table-header>
    <app-table-header>Name</app-table-header>
    <app-table-header *ngIf="!deactivated" class="flex-half"></app-table-header>
    <app-table-header *ngIf="!deactivated" class="tools-cell"
      >Tools</app-table-header
    >
    <app-table-header>Last login</app-table-header>
    <app-table-header class="language-cell">Language</app-table-header>
    <app-table-header>Email</app-table-header>
    <app-table-header class="flex-half">ID</app-table-header>
    <app-table-header *ngIf="!deactivated" class="icon-cell"></app-table-header>
  </app-table-headers>

  <ng-template #empty>
    <app-table-content-empty>
      <ng-container nodata>
        <p><strong *ngIf="!users">Enter search word to find users</strong></p>

        <p id="user-list-empty" *ngIf="users && !users.length">
          No users found
        </p>
      </ng-container>
    </app-table-content-empty>
  </ng-template>

  <app-table-content *ngIf="users && users.length; else empty">
    <app-table-row
      *ngFor="let user of users"
      [ngbTooltip]="getExpireTooltip(user)"
    >
      <app-table-cell class="flex-half picture-cell">
        <ng-container *ngIf="user.accountUserType === UserTypes.Customer">
          <img [src]="user.picture" width="50px" height="50px" />
        </ng-container>
        <ng-container *ngIf="user.accountUserType === UserTypes.Staff">
          <app-svg-icon icon="a-logo" width="50" height="50"></app-svg-icon>
        </ng-container>
        <ng-container *ngIf="user.accountUserType === UserTypes.Partner">
          <div class="icon-cell">
            <i class="fas fa-handshake"></i>
          </div>
        </ng-container>
      </app-table-cell>

      <app-table-cell>
        <a routerLink="/au/users/{{ user.id }}">
          <strong>{{ user.name }}</strong>
        </a>
      </app-table-cell>
      <app-table-cell
        *ngIf="!deactivated"
        class="flex-half justify-content-center buttons"
      >
        <span
          ngbTooltip="Manage users permissions on this account"
          placement="left"
        >
          <a
            class="btn btn-primary btn-sm"
            routerLink="/au/accounts/{{ accountId }}/users/{{ user.id }}"
          >
            <i class="fas fa-lock"></i>
            Permissions
          </a>
        </span>
      </app-table-cell>
      <app-table-cell *ngIf="!deactivated" class="tools-cell">
        <ng-container *ngIf="user.accountUserType !== UserTypes.Customer">
          <span class="badge badge-primary">
            {{ user.accountUserType }}
          </span>
        </ng-container>
        <ng-container *ngIf="user.roles.length && !isOnlyUser(user.roles)">
          <span *ngFor="let role of user.roles" class="badge badge-success">
            {{ role }}
          </span>
        </ng-container>
        <ng-container *ngIf="!user.roles.length || isOnlyUser(user.roles)">
          <span
            *ngFor="let license of getAccountLicenses()"
            [ngbTooltip]="license.displayName"
          >
            <app-svg-icon
              *ngIf="hasIcon(license.code)"
              [icon]="getToolIcon(user.toolPermissions, license.code)"
            ></app-svg-icon>
          </span>
        </ng-container>
      </app-table-cell>
      <app-table-cell>{{
        user.lastLogin | date: 'yyyy/MM/dd H:mm'
      }}</app-table-cell>
      <app-table-cell class="language-cell">
        <span *ngIf="user.language && user.format"
          >{{ user.language }} - {{ user.format }}</span
        >
      </app-table-cell>
      <app-table-cell>{{ user.email }}</app-table-cell>
      <app-table-cell class="flex-half">
        <span ngbTooltip="Copy ID" placement="left">
          <button (click)="copyUserId(user.id)" class="btn btn-primary btn-sm">
            <i class="fa-copy fas"></i>
          </button>
        </span>
        {{ user.id }}
      </app-table-cell>
      <app-table-cell
        *ngIf="!deactivated"
        class="icon-cell justify-content-center buttons"
      >
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-sm" id="dropdownMenuButton" ngbDropdownToggle>
            ...
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
            <button
              ngbDropdownItem
              [disabled]="!deactivated && !support && usersCount <= 1"
              (click)="openDeleteFromAccountModal.emit(user)"
            >
              <span class="btn btn-danger btn-sm">
                <i class="fas fa-trash"></i>
              </span>
              Disable on this account
            </button>
          </div>
        </div>
      </app-table-cell>
    </app-table-row>
  </app-table-content>
  <div *ngIf="!deactivated && !support && usersCount <= 1">
    <p class="warning">
      <i class="fa fa-exclamation-triangle"></i> At least one active user is
      required for account delete operations. When the account is deleted, this
      user will be automatically removed as well. You are not able to disable
      this last active user now.
    </p>
  </div>
</app-table>
